// 换船: going from one boat to another (the office raft and the 活动舱, by the 码头 / 跳板 or the boat menu: public/boats.js,
// public/floors.js) without the 上船 card again (artin: 「切换船的时候，不用进这个 onboarding … 可以用转场动画」).
// A boat is its own office, so the page still reloads; this covers it: the sea rises over the old boat with a little
// ship sailing across and 「前往 活动舱…」, the new page starts under the same cover, boards by itself (the same
// sessionStorage flag as 发版预告's soft reload: public/notice.js takeReboard) with the choices it had (the mic muted or
// not; the rest is kept by the page anyway), and the sea goes down once my otter is on the new deck.
import { t } from '/i18n.js';

const KEY = 'deck.voyage', REBOARD = 'deck.reboard', FRESH_MS = 60_000;

/** Leaving: remember where to and the mic, and that the next page boards by itself. walk: walked across the 码头 /
 *  跳板 (public/boats.js): the short cover on both pages, no ship. */
export function setSail({ to, muted, walk = false }) {
  try {
    const name = String(to ?? '');
    sessionStorage.setItem(KEY, JSON.stringify({ to: name, muted: !!muted, walk: !!walk, at: Date.now(),
      title: t(walk ? 'voyage.walk' : 'voyage.to', { name: name || t('voyage.boat') }), wait: t('voyage.wait') }));
    sessionStorage.setItem(REBOARD, String(Date.now()));
  } catch {}
}
/** The page stopped short of boarding (a card to show: signed out, offline, …): the next load shows the 上船 card. */
export function dropReboard() { try { sessionStorage.removeItem(REBOARD); } catch {} }
// Back to the page that sailed off (the back-forward cache): its sea is still up; take it away
addEventListener('pageshow', (e) => { if (e.persisted) document.getElementById('voyage')?.remove(); });
function releaseBootCover() {
  document.documentElement.classList.remove('voyage-boot');
  document.getElementById('voyage-boot')?.remove();
  delete window.__deckVoyageBoot;
}
/** Arriving: what setSail kept (read once), or null (not a boat switch, or a stale one). */
export function takeVoyage() {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY) ?? 'null'); sessionStorage.removeItem(KEY);
    if (v && typeof v.at === 'number' && Date.now() - v.at < FRESH_MS) return v;
  } catch {}
  releaseBootCover(); return null;
}

// The arriving page's inline #voyage-boot in index.html mirrors this appearance before this module can load.
const CSS = `#voyage{position:fixed;inset:0;z-index:2000;overflow:hidden;background:#3d9bd1;display:flex;align-items:center;justify-content:center;
  font:14px/1.4 var(--ui-font,-apple-system,system-ui,sans-serif);color:#1b1410}
#voyage.in{animation:vyIn .45s steps(9,end) both}#voyage.out{animation:vyOut .5s steps(10,end) both}
#voyage.walk.in{animation:vyFade .22s steps(4,end) both}#voyage.walk.out{animation:vyFade .3s steps(5,end) reverse both}
#voyage.walk .vy-boat,#voyage.walk .vy-sea{display:none}#voyage.walk .vy-card{margin-top:0}
#voyage::before{content:'';position:absolute;inset:-40px 0 0;background:repeating-linear-gradient(180deg,transparent 0 22px,#86cdf1 22px 24px,transparent 24px 46px,#2f82b7 46px 48px);
  opacity:.55;animation:vyWaves 1.2s linear infinite}
#voyage .vy-sea{position:absolute;left:0;right:0;top:50%;height:4px;background:#f2fbff;opacity:.8}
#voyage .vy-boat{position:absolute;top:calc(50% - 90px);left:0;width:144px;height:96px;animation:vySail 2.4s linear infinite}
#voyage .vy-boat svg{width:144px;height:96px;image-rendering:pixelated;animation:vyBob .6s steps(2,end) infinite alternate}
#voyage .vy-card{position:relative;margin-top:150px;padding:12px 22px;background:#fff8e7;border:3px solid #1b1410;border-radius:14px;
  box-shadow:4px 5px 0 #1b141044;text-align:center}
#voyage .vy-card strong{display:block;font-size:20px}
@keyframes vyIn{from{clip-path:inset(100% 0 0 0)}to{clip-path:inset(0 0 0 0)}}
@keyframes vyOut{from{clip-path:inset(0 0 0 0)}to{clip-path:inset(0 0 100% 0)}}
@keyframes vyFade{from{opacity:0}to{opacity:1}}
@keyframes vyWaves{from{transform:translateY(0)}to{transform:translateY(46px)}}
@keyframes vySail{from{transform:translateX(-160px)}to{transform:translateX(calc(100vw + 20px))}}
@keyframes vyBob{from{transform:translateY(0)}to{transform:translateY(3px)}}
@media (prefers-reduced-motion:reduce){#voyage,#voyage::before,#voyage .vy-boat,#voyage .vy-boat svg{animation:none}#voyage .vy-boat{left:calc(50% - 72px)}}`;
// the little ship: hull, a navy band, a mast, two sails and a pennant, on a 24 x 16 pixel grid
const SHIP = `<svg viewBox="0 0 24 16" shape-rendering="crispEdges" aria-hidden="true">
<rect x="11" y="1" width="1" height="11" fill="#5e3a22"/><polygon points="12,2 12,7 17,7" fill="#f8ecd4"/><polygon points="11,3 11,9 6,9" fill="#fffaf0"/>
<rect x="12" y="1" width="3" height="1" fill="#ea5a4c"/><polygon points="2,11 22,11 19,15 5,15" fill="#9d683d"/><rect x="3" y="12" width="18" height="1" fill="#3a55a0"/>
<rect x="5" y="15" width="14" height="1" fill="#bd3c37"/></svg>`;

/** The cover: `rise` (leaving: the sea comes up over the page) or already up (arriving). done(): it goes down and away.
 *  walk: walking across the 码头 / 跳板 to the boat moored alongside: a quick fade with 「走上 X」, no ship. */
export function voyageCover(to, { rise = false, walk = false } = {}) {
  if (!document.getElementById('voyage-css')) { const s = document.createElement('style'); s.id = 'voyage-css'; s.textContent = CSS; document.head.append(s); }
  document.getElementById('voyage')?.remove();
  const el = document.createElement('div'); el.id = 'voyage'; el.setAttribute('role', 'status'); el.className = (walk ? 'walk ' : '') + (rise ? 'in' : '');
  const sea = document.createElement('div'); sea.className = 'vy-sea';
  const boat = document.createElement('div'); boat.className = 'vy-boat'; boat.innerHTML = SHIP;
  const card = document.createElement('div'); card.className = 'vy-card';
  const title = document.createElement('strong'); title.textContent = t(walk ? 'voyage.walk' : 'voyage.to', { name: to || t('voyage.boat') });
  const sub = document.createElement('span'); sub.textContent = t('voyage.wait');
  card.append(title, sub); el.append(sea, boat, card); document.body.append(el);
  releaseBootCover(); // the arriving cover is in place before the first-paint cover comes away
  let gone = false;
  const done = () => { if (gone) return; gone = true; el.className = (walk ? 'walk ' : '') + 'out'; setTimeout(() => el.remove(), 520); };
  setTimeout(done, 20_000); // never stuck under the sea: a page that can't board shows what it has
  return { done };
}
